@if (loader.getLoading()) {
<div class="spinner-container">
    <div class="spinner"></div>
</div>
}
